var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"actions"},[_c('ul',_vm._l((_vm.packServices),function(s,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(s.libelle)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }